import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { Col, Row, Toast } from 'react-bootstrap';
import { Modal } from '@redq/reuse-modal';
import UploadService from "../../services/FileUploadService";
import { Card, CardContent, Divider, Switch, Typography } from '@material-ui/core';
import { PATHS3, S3_DS_BUCKET_MAINTENANCE, S3_FILENAME_JSON_MAINTENANCE } from "../../constants/Constant";
import { useMaintenanceMode } from '../../components/MaintenanceMode/MaintenanceModeProvider';
import { fetchFeatureMaintenance } from '../../store/actions/dashboardAction';
import MaintenanceStaticFile from '../../assets/maintenance/file-maintenance/maintenance_mode.json';
import UnMaintenanceStaticFile from '../../assets/maintenance/file-un-maintenance/maintenance_mode.json';

const URL_FILE_MAINTENANCE = `${PATHS3}${S3_DS_BUCKET_MAINTENANCE}/${S3_FILENAME_JSON_MAINTENANCE}`;

// style
const HelpPageWrapper = styled.div`
    background-color: #f7f7f7;
    position: relative;
    padding: 50px 0 50px 0;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: 989px) {
    padding-top: 70px;
    }
`;

const AdminMaintenanceMode = (props) => {
    const [toastMessage, setToastMessage] = useState("Delete successful");
    const [toastBgColor, setToastBgColor] = useState('bg-success');
    const [showToast, setShowToast] = useState(false);
    const [mounted, setMounted] = useState(false); //state to control useEffect
    const { isMaintenanceMode, setMaintenanceMode } = useMaintenanceMode();

    const handleToast = () => {
        
        let timeout = setTimeout(() => {
          setShowToast(true);
        }, 500);
        return () => clearTimeout(timeout);
    }

    const handleMaintenance = () => {
        if(isMaintenanceMode){
            handleUpload(UnMaintenanceStaticFile)
        }else{
            handleUpload(MaintenanceStaticFile)
        }
    }

    const handleUpload = (filePath) => {
        // Create a Blob from the path file JSON content
        const blob = new Blob([JSON.stringify(filePath)], { type: 'application/json' });
        
        // Create a File object from the Blob
        const file = new File([blob], S3_FILENAME_JSON_MAINTENANCE, { type: 'application/json' });
        
        sendFilesToServer(file);
    };

    const sendFilesToServer = (file) => {
        const formData = new FormData();
        formData.append("file", file)
        UploadService.activateMaintenanceMode(formData )
            .then(response => {
            if(response.data.success) {
                setMaintenanceMode(!isMaintenanceMode);
                setToastMessage('Updated Successfully!');
                setToastBgColor('bg-success')
                handleToast();
            }
        });
    }

    const fetchMaintenance = async(URL_FILE_MAINTENANCE, setMaintenanceMode) => {
        try {
            await fetchFeatureMaintenance({
                URL_FILE_MAINTENANCE: URL_FILE_MAINTENANCE,
                setMaintenanceMode: setMaintenanceMode, 
                setMounted: setMounted
            });
        } catch (error) {
            setMaintenanceMode(false)
            localStorage.setItem("maintenanceMode", false);
            setMounted(true);
            console.log("err", error);
        }
    }

    useEffect(() => {
        if(mounted === false){
            fetchMaintenance(URL_FILE_MAINTENANCE, setMaintenanceMode);
        }
    }, [mounted, setMaintenanceMode])

  return (
    <Modal>
        <HelpPageWrapper>
            <Row className='mb-4'>
                <Col sm={11}>
                    <h4>Maintenance Systems</h4>
                </Col>
            </Row>
            <Row>
                <Col sm={3}>
                    <Card>
                        <CardContent style={{padding: 0}}>
                            <Typography 
                                color="textSecondary" 
                                gutterBottom 
                                component={"h5"} 
                                className='text-center' 
                                style={{
                                    fontWeight: 900, 
                                    fontSize: 22,
                                    padding: 16,
                                    margin: 0
                                }}
                            >
                                Maintenance Mode
                            </Typography>
                            <Divider />
                            <Typography 
                                color="textSecondary"
                                className='text-center'
                                style={{padding: "20px 16px"}}
                            >
                                <Switch
                                    checked={isMaintenanceMode}
                                    onChange={handleMaintenance}
                                    name="maintenaine"
                                    color="primary"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </Typography>
                        </CardContent>
                    </Card>
                </Col>
            </Row>

            <Toast className={toastBgColor}
                onClose={() => setShowToast(false)}
                show={showToast}
                delay={3000}
                autohide
                style={{
                    position: 'fixed',
                    top: 70,
                    right: 35,
                    zIndex: 1041,
                }}
            >
                <Toast.Header>
                    <strong className="mr-auto">{toastMessage}</strong>
                </Toast.Header>
            </Toast>
        </HelpPageWrapper>
    </Modal>
  )
}

export default AdminMaintenanceMode;